﻿let $ = require('jquery');

let Sizer = function (customOptions) {
	let defaults = {
		element: null,
		sizes: [
			//{
			//	maxWidth: 900,
			//	cssClass: 'jnf-widget-menu-2-narrow'
			//}
		],
		subelement: null
	};
	let options = $.extend({}, defaults, customOptions);
	let $element = $(options.element);

	let orderedSizes = options.sizes.sort(function (sizeDefinition1, sizeDefinition2) {
		return sizeDefinition1.maxWidth - sizeDefinition2.maxWidth;
	});

	let selectSize = function () {
		
		let candidateSizeIndex = 0;
		let found = false;
		let width;
		
		if (options.subelement !== null) {
			width = $element.find(options.subelement).width();
		} else {
			width = $element.width();
		}

		for (let sizeIndex = 0; sizeIndex < orderedSizes.length; sizeIndex++) {
			$element.removeClass(orderedSizes[sizeIndex].cssClass);
		}

		while (candidateSizeIndex < orderedSizes.length && !found) {
			let candidateSize = orderedSizes[candidateSizeIndex];

			if (width < candidateSize.maxWidth) {
				found = true;
				$element.addClass(candidateSize.cssClass);
			} else {
				candidateSizeIndex++;
			}
		}
	};

	let onWindowResize = function () {
		selectSize();
	};

	$(window).on('resize', onWindowResize);

	selectSize();
};

module.exports = Sizer;